import { render, staticRenderFns } from "./affairsQuery.vue?vue&type=template&id=85fb227a&scoped=true"
import script from "./affairsQuery.vue?vue&type=script&lang=js"
export * from "./affairsQuery.vue?vue&type=script&lang=js"
import style0 from "./affairsQuery.vue?vue&type=style&index=0&id=85fb227a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb227a",
  null
  
)

export default component.exports